module.exports = __webpack_public_path__ + "static/media/test19_1.4b27300e.png";